<script setup lang="ts">
import { NavigationMenuContent, NavigationMenuIndicator, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuRoot, NavigationMenuTrigger } from "reka-ui";
import type { NavMenuItem } from "@/schemas/nav-menu-item";

const { siteOptions } = useSiteOptions();
function showSeparator(item: NavMenuItem, i: number) {
  if (!siteOptions.value) return false;
  if (i === siteOptions.value.main_menu_items.length - 1) return false;
  if (item.class.includes("menu-orange")) return false;
  if (siteOptions.value.main_menu_items[i + 1]?.class.includes("menu-orange")) return false;
  return true;
}
</script>

<template>
  <NavigationMenuRoot v-if="siteOptions" id="menu-desktop" :disable-hover-trigger="true" :disable-pointer-leave-close="true" class="relative bg-dark text-sm font-semibold text-white xl:text-xl">
    <NavigationMenuList class="container flex justify-between">
      <template v-for="(item, i) in siteOptions.main_menu_items" :key="item.id">
        <NavigationMenuItem class="item" :class="item.class">
          <template v-if="item.children.length > 0">
            <NavigationMenuTrigger class="group flex items-center gap-3 py-6 hover:text-orange xl:py-8">
              {{ item.title }}
              <span class="i-lucide-chevron-down size-6 text-orange transition-transform ease-in group-data-[state=open]:-rotate-180" />
            </NavigationMenuTrigger>
            <NavigationMenuContent class="animation-fade links:link-primary absolute inset-x-0 top-full flex bg-white text-black shadow-lg">
              <div class="container grid auto-cols-auto grid-flow-col gap-8 font-medium">
                <ul v-for="column in item.children" :key="column.id" class="flex flex-col gap-4 py-8" :class="column.class">
                  <li v-for="child in column.children" :key="child.id" class="item" :class="child.class">
                    <NavigationMenuLink :href="child.url" :target="child.target" class="link">
                      {{ child.title }}
                    </NavigationMenuLink>
                  </li>
                </ul>
              </div>
            </NavigationMenuContent>
          </template>
          <template v-else>
            <NavigationMenuLink :href="item.url" :target="item.target" class="flex py-6 hover:text-orange xl:py-8">
              {{ item.title }}
            </NavigationMenuLink>
          </template>
        </NavigationMenuItem>
        <li v-if="showSeparator(item, i)" class="my-3 w-px bg-light" />
        <NavigationMenuIndicator class="absolute bottom-0 flex h-2 w-[--reka-navigation-menu-indicator-size] translate-x-[--reka-navigation-menu-indicator-position] items-end justify-center overflow-hidden bg-primary transition data-[state=hidden]:opacity-0" />
      </template>
    </NavigationMenuList>
  </NavigationMenuRoot>
</template>
